import Skeleton from '../../Skeleton';

import { Container } from './styles';

const LoadingCarouselNews: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container>
      <Skeleton className="row" />
    </Container>
  );
};

export default LoadingCarouselNews;
